import { ArgumentError } from '../utils/errors';

import { BaseAPIModel } from '@weezevent/weezjs-core';

export const DISTRIBUTOR_ID_FNAC = 1;
export const DISTRIBUTOR_ID_DIGITICK = 2;
export const DISTRIBUTOR_ID_TICKETNET = 3;
export const DISTRIBUTOR_ID_PARTNERS = 1663;
export const DISTRIBUTOR_ID_MALCOLM = 1210; //guests platform deprecated
export const TICKET_SWAP_DISTRIBUTOR = 1201;
export const PASS_CULTURE_DISTRIBUTOR = 3017;

export default class Distributor extends BaseAPIModel {
    fields() {
        return {
            id: { primaryKey: true }
        };
    }

    static getListUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][Distributor][getAll] organizationId is mandatory`);
        }

        return `/ticket/organizations/${organizationId}/distributors`;
    }
}
